// @ts-expect-error
import { AES, enc } from "react-native-crypto-js";
// @ts-expect-error
import { REACT_APP_ENCRYPTION_SECRET_KEY } from "@env";

export const encrypt = (data: any) => AES.encrypt(JSON.stringify(data), REACT_APP_ENCRYPTION_SECRET_KEY).toString();

export const decrypt = (encryptedData: string) =>
  JSON.parse(AES.decrypt(encryptedData, REACT_APP_ENCRYPTION_SECRET_KEY).toString(enc.Utf8));
